import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import PublicProject from 'pages/PublicProject'

const publicProjectSearchSchema = z.object({
  tab: z.enum(['list', 'map']).optional().default('list'),
})

const publicProjectSearchDefaults = { tab: 'list' } as const

export const Route = createFileRoute('/public/projects/$id')({
  component: PublicProject,
  validateSearch: zodValidator(publicProjectSearchSchema),
  search: {
    middlewares: [stripSearchParams(publicProjectSearchDefaults)],
  },
})
